/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type accessibility_enableAccessibilityModeMutationVariables = {
    hasEnabledAccessibilityMode: boolean;
};
export type accessibility_enableAccessibilityModeMutationResponse = {
    readonly updateUserPreference: {
        readonly userPreference: {
            readonly hasEnabledAccessibilityMode: boolean;
        } | null;
    };
};
export type accessibility_enableAccessibilityModeMutation = {
    readonly response: accessibility_enableAccessibilityModeMutationResponse;
    readonly variables: accessibility_enableAccessibilityModeMutationVariables;
};



/*
mutation accessibility_enableAccessibilityModeMutation(
  $hasEnabledAccessibilityMode: Boolean!
) {
  updateUserPreference(hasEnabledAccessibilityMode: $hasEnabledAccessibilityMode) {
    userPreference {
      hasEnabledAccessibilityMode
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "hasEnabledAccessibilityMode"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "hasEnabledAccessibilityMode",
    "variableName": "hasEnabledAccessibilityMode"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasEnabledAccessibilityMode",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accessibility_enableAccessibilityModeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPreferenceResult",
        "kind": "LinkedField",
        "name": "updateUserPreference",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserPreference",
            "kind": "LinkedField",
            "name": "userPreference",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accessibility_enableAccessibilityModeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateUserPreferenceResult",
        "kind": "LinkedField",
        "name": "updateUserPreference",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserPreference",
            "kind": "LinkedField",
            "name": "userPreference",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "98076c72fa1dc4fa4be0c00945fcf71d",
    "id": null,
    "metadata": {},
    "name": "accessibility_enableAccessibilityModeMutation",
    "operationKind": "mutation",
    "text": "mutation accessibility_enableAccessibilityModeMutation(\n  $hasEnabledAccessibilityMode: Boolean!\n) {\n  updateUserPreference(hasEnabledAccessibilityMode: $hasEnabledAccessibilityMode) {\n    userPreference {\n      hasEnabledAccessibilityMode\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '5c3835626fdf22f4eb303fa0705f9e44';
export default node;
